import Backbone from 'backbone';
import _ from 'underscore';
import Tab from './Tab';
import '../backbone-relational-isomorphic';
var SiteConf = Backbone.RelationalModel.extend({

    relations: [
        {
            type: Backbone.HasMany,
            key: 'tabs',
            relatedModel: Tab,
            collectionType: Backbone.Collection
        }
    ],

    defaults: {
        template: 'business'
    },

    initialize: function() {
        this.listenTo(this, 'change:currentTab', this.setSelectedTab);
    },

    url: function() {
        var url = this.get('isPreview') ? 'events/' + this.id + '/site_conf?preview=true' : 'events/' + this.id +'/site_conf';
        return '/api/v1/' + url;
    },

    parse: function(response) {
        this.parseSelectedTab(response);
        this.parseFontName(response);
        this.shouldShowMoreTab(response);
        return response;
    },

    toJSON: function(options) {
        var toJSON = Backbone.RelationalModel.prototype.toJSON.call(this);
        toJSON.navColors = {
            color0: toJSON.navColor0,
            color1: toJSON.navColor1,
            color2: toJSON.navColor2,
            color3: toJSON.navColor3,
            color4: toJSON.navColor4,
            color5: toJSON.navColor5
        };
        return toJSON;
    },

    shouldShowMoreTab: function(response) {
        var visibleTabs = _.where(response.tabs, {visible: true});
        var hasLogo = response.navigationBarLogoVisible && response.navigationBarLogo;

        response.showMoreTab = visibleTabs && (visibleTabs.length > this.getMaxTabs(hasLogo));
    },

    getMaxTabs: function(hasLogo) {
        return hasLogo ? 7 : 8;
    },

    parseFontName: function(response) {
        // transform font name of the shape: "'Alfa Slab One', cursive" into "Alfa Slab One"
        var fontName = response.font.split(',')[0];
        fontName = fontName.replace(/'/g, '');
        response.urlFontName = fontName;
    },

    setSelectedTab: function() {
        var tabIdOrType = parseInt(this.get('currentTab'));
        var tabs = this.get('tabs');
        var selectedTab;
        if (_.isNaN(tabIdOrType)) {
            selectedTab = tabs.findWhere({'type': this.get('currentTab')});
        } else {
            selectedTab = tabs.findWhere({'id': tabIdOrType});
        }
        tabs.invoke('set', {selected: false}, {silent: true});
        selectedTab && selectedTab.set('selected', true);
    },

    parseSelectedTab: function(response) {
        var tabIdOrType = parseInt(this.get('currentTab'));
        var selectedTab;
        if (_.isNaN(tabIdOrType)) {
            selectedTab = _.findWhere(response.tabs, {'type': this.get('currentTab')});
        } else {
            selectedTab = _.findWhere(response.tabs, {'id': tabIdOrType});
        }
        selectedTab && (selectedTab.selected = true);
    },

    getTabIdByType: function(type) {
        var tab = this.get('tabs').findWhere({type: type});
        var tabId = tab && tab.get('id');
        return tabId || '';
    },

    capitalizeFirstLetter: function(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },

    getTabNameById: function(id) {
        var name = '';
        var models = this.get('tabs') && this.get('tabs').models;
        _.each(models, function(tab) {
            if (tab.id == id.toString()) {
                var tabType = tab.get('type');
                switch (tabType) {
                case 'home' :
                    name = '';
                    break;
                case 'custom' :
                    name = tab.get('name');
                    break;
                default :
                    name = tabType;
                }
            }
        });
        return this.capitalizeFirstLetter(name);
    }

});

export default SiteConf;

